import { type PickupPointPaymentMethod, type PickupPointPaymentMethodKeys } from '../types/PickupPointPaymentMethod';

export const PickupPointPaymentMethods: Record<PickupPointPaymentMethodKeys, PickupPointPaymentMethod> = {
    ALREADY_PAID: 'already_paid',
    CASH_ON_RECEIPT: 'cash_on_receipt',
    CARD_ON_RECEIPT: 'card_on_receipt',
} as const;
